import * as Constants from './constants'

const initialState = {
  addContestLoading: false,
  getContestLoading: false,
  ownerLoading: false,
  testLoading: false,
}

const reducer = function contestReducer (state = initialState, action) {
  // console.log('reducer add contest ====>', action)
  switch (action.type) {
    case Constants.ADD_REQUEST:
      return {
        ...state,
        addContestLoading: true,
        messages: [{
          body: 'Adding Contest...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.ADD_SUCCESS:
      return {
        ...state,
        addContest: action.result.meta,
        addContestLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.ADD_ERROR:
      return {
        ...state,
        addContestLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.GET_REQUEST:
      return {
        ...state,
        getContestLoading: true,
        messages: [{
          body: 'Getting Contest...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.GET_SUCCESS:
      return {
        ...state,
        getContest: action.result,
        getContestLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.GET_ERROR:
      return {
        ...state,
        getContestLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.ADD_CLEAR:
      return {
        ...state,
        addContestLoading: false,
        messages: [],
        errors: [],
      }

    case Constants.OWNER_REQUEST:
      return {
        ...state,
        ownerLoading: true,
        messages: [{
          body: 'Getting Owners...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.OWNER_SUCCESS:
      return {
        ...state,
        owners: action.result.data || [],
        ownerLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.OWNER_ERROR:
      return {
        ...state,
        ownerLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.TEST_REQUEST:
      return {
        ...state,
        testLoading: true,
        messages: [{
          body: 'Getting Test...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.TEST_SUCCESS:
      return {
        ...state,
        tests: action.result.data || [],
        testLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.TEST_ERROR:
      return {
        ...state,
        testLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.LOCATION_REQUEST:
      return {
        ...state,
        locationLoading: true,
        messages: [{
          body: 'Getting Location...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.LOCATION_SUCCESS:
      return {
        ...state,
        locations: action.result.data || {},
        locationLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.LOCATION_ERROR:
      return {
        ...state,
        locationLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

      case Constants.SKILL_REQUEST:
      return {
        ...state,
        skillLoading: true,
        messages: [{
          body: 'Getting Skill...!',
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.SKILL_SUCCESS:
      return {
        ...state,
        skills: action.result.data || [],
        skillLoading: false,
        messages: [{
          body: action.result.meta.message,
          time: new Date(),
        }],
        errors: [],
      }
    case Constants.SKILL_ERROR:
      return {
        ...state,
        skillLoading: false,
        messages: [],
        errors: state.errors.concat[{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    case Constants.LOCATION_CLEAR:
      return {
        ...state,
        locations: undefined,
        messages: [],
        errors: [],
      }

    case Constants.SKILL_CLEAR:
      return {
        ...state,
        skills: undefined,
        messages: [],
        errors: [],
      }

    default:
      return state
  }
}

export default reducer
